import React, {useState, useEffect} from "react";
import {Button, Drawer, Form, message} from "antd";
import {observer} from "mobx-react-lite";
import {rolesModel} from "../../../../../entities/roles";
import {usersModel} from "../../../../../entities/users";
import {Inputs} from "./Inputs/Inputs";
import {Selects} from "./Selects/Selects";
import {Errors} from "./Errors/Errors";
import {UsersTable} from "./Table/Table";

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 10 },
};


export const UsersSection = observer(() => {
  const [form] = Form.useForm();
  const [isOpenedDrawer, setOpenedDrawer] = useState(false)
  const [editableUserId, setEditableUserId] = useState(null)

  useEffect(() => {
    if (!isOpenedDrawer) {
      usersModel.setErrors({})
      setEditableUserId(null)
      form.resetFields()
    }
    // eslint-disable-next-line
  },[isOpenedDrawer])


  useEffect(() => {
    usersModel.fetch()
    // role names in the table and the roles of the form
    rolesModel.fetch()
  }, [])

  const handleResponse = (response) => {
    if (response && response.status === 200) {
      setOpenedDrawer(false)
      usersModel.fetch()
    } else {
      // the drawer shows the server's message (Errors); a lost connection gets a note here
      !response && message.error('Произошла ошибка')
    }
  }

  const handleForm = async (values) => {
    const {confirmPassword, newPassword, ...restUserInfo} = values
    restUserInfo.phone = restUserInfo.phone.replace(/\D/g,'')
    const formData = new FormData();
    Object.entries(restUserInfo).forEach(item => {
      const [key, value] = item
      // roles go as "1,3"
      return formData.append(`data[${key}]`, Array.isArray(value) ? value.join(',') : value || '');
    })
    if (newPassword) formData.append(`data[newPassword]`, newPassword);
    const response = editableUserId
      ? await usersModel.update(editableUserId, formData)
      : await usersModel.create(restUserInfo)

    handleResponse(response)
  }

  return (
    <>
      <UsersTable
        form={form}
        setEditableUserId={setEditableUserId}
        setOpenedDrawer={setOpenedDrawer}
        handleResponse={handleResponse}
      />
      <Drawer
        title={`${editableUserId ? 'Изменить' : 'Создать'} пользователя`}
        width={720}
        onClose={() => setOpenedDrawer(false)}
        visible={isOpenedDrawer}
        bodyStyle={{paddingBottom: 80}}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() => setOpenedDrawer(false)} style={{marginRight: 8}}>
              Отменить
            </Button>
            <Button form="userForm" type="primary" htmlType="submit">
              {editableUserId ? 'Изменить' : 'Создать'}
            </Button>
          </div>
        }
      >
        <Errors/>
        <Form id="userForm" form={form} onFinish={handleForm}>
          <Inputs editMode={editableUserId} formItemLayout={formItemLayout} />
          <Selects formItemLayout={formItemLayout}/>
        </Form>
      </Drawer>
    </>
  )
})
